import { criarFinalizador } from '@/uteis/action/devolver/finalizador'

export const arquivar = (dados, dadosSessao) => {
  var arquivamento = {
    ...dados,
    usuario: criarFinalizador(dadosSessao, true)
  }

  return arquivamento
}
